import { V3toVector3 as i } from "../index9.js";
function h(o, c) {
  const l = o.slice(0, o.length - 1), t = c.slice(0, c.length - 1), p = l.map(i), s = t.map(i).map((n) => n.distanceToSquared(p[0])), a = s.indexOf(Math.min(...s)), e = [];
  for (let n = a; n < a + t.length; n++)
    e.push(t[n % t.length]);
  return e.push(e[0]), e;
}
export {
  h as alignPolygons
};
//# sourceMappingURL=index.js.map
